import React, { useEffect, useRef, useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { useToggle } from '@/common/hooks/index';
import Modal from '@/common/components/Modal/index';
import styles from '@/common/containers/Modals/PromptSaveModal/styles.less';
import { useTranslation } from 'react-i18next';

const PromptSaveModal = ({
  when,
  cancelText,
  confirmText,
  title,
  description,
  onSave = async () => {},
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [show, toggleShow] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const [saving, setSaving] = useState(false);
  const isMounted = useRef(false);

  const closeModalNoSave = () => {
    toggleShow(false);
    setConfirm(true);
  };

  const onBlockedNavigation = (nextLocation) => {
    if (!confirm) {
      toggleShow(true);
      setNextLocation(nextLocation);
      return false;
    }
    return true;
  };

  const onConfirmSave = async () => {
    try {
      setSaving(true);
      await onSave();
      setSaving(false);
    } catch (err) {
      setSaving(false);
      console.log(err);
      return toggleShow(false);
    }
    toggleShow(false);
    setConfirm(true);
  };

  useEffect(() => {
    if (!confirm || !nextLocation) return;
    history.push(nextLocation.pathname);

    if (isMounted) {
      setNextLocation(null);
      setConfirm(false);
    }
  }, [confirm, nextLocation]);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const resolvedTitle = title || t('Save updates?');
  const resolvedDescription =
    description || t('Do you want to save updates before you leave?');
  const resolvedCancelText = cancelText || t('Leave without saving');
  const resolvedConfirmText = confirmText || t('Save');

  return (
    <>
      <Prompt when={when} message={onBlockedNavigation} />
      <Modal className={styles.modal} open={show} overlay>
        <h4 className={styles.modalTitle}>{resolvedTitle}</h4>
        <p className={styles.modalDescription}>{resolvedDescription}</p>
        <div className={styles.modalBtns}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={closeModalNoSave}
          >
            {!saving ? resolvedCancelText : t('Leave')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirmSave}
            disabled={saving}
          >
            {resolvedConfirmText}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default PromptSaveModal;
